import React from 'react'
import { useDropzone } from 'react-dropzone'
import { toast } from 'react-toastify'
import { Button, Dropdown, Form, Image, Input, Progress } from 'semantic-ui-react'
import db, { messaging, storage,firebase } from '../../../../utils/firebase'
import './AddPelicula.scss'
import {v4 as uuidv4} from 'uuid'
import noImage from '../../../../img/noimage.png'
import {map} from 'lodash'
import ListaDeTiposDePeliculas from '../../../listaDeTiposDePeliculas/ListaDeTiposDePeliculas'
import { getMessaging, getToken } from "firebase/messaging";
import axios from 'axios';






export default function AddPelicula(props) {

    const {user, setShowModal, setTitleModal, setContentModal} = props

    const agregarAlbum = ()=>{
        setShowModal(true)
        setTitleModal("Agregar Pelicula")
        setContentModal(  <DisplayAlbum setShowModal={setShowModal} user={user}  /> )
    }

    return (
        <div className="profile-admin-album" >
            <h2>Pelicula</h2>
            <Button onClick={agregarAlbum} >Agregar Pelicula</Button>
        </div>
    )
}

function DisplayAlbum (props){

    const {setShowModal}= props

    const [iseLoading, setIsloading] = React.useState(false)
    const [files, setFiles] = React.useState(null)
    const [porcentajePoster, setPorcentajePoster] = React.useState(null)
    const [tipoDePelicula,setTipoDePelicula] = React.useState("")
    const [urlVideoForm,setUrlVideoForm] = React.useState()
    const [errors,setErrors] = React.useState({})
    const [showNotificar,setShowNotificar]=React.useState(false)
    const [buscar,setBuscar]=React.useState([])
    const [reload,setReload]=React.useState(false)

    
    const [albumName, setAlbumName] = React.useState({
        type:tipoDePelicula,
        title:"",
        description:"",
        urlTrailer:"",
        urlVideo:"",
        titleNotificacion:"",
        messageNotificacion:"",
        buscar:"",
        urlImagePoste:""

    })

    const lista = [
        {
            title:"terror",id:0
        },
        {
            title:"accion",id:1
        },
        {
            title:"romance",id:2
        },
        {
            title:"coreanas",id:3
        },
        {
            title:"comedia",id:4
        },
        {
            title:"adolescentes",id:5
        },
        {
            title:"drama",id:6
        },
        {
            title:"animado e infantil",id:7
        },
        {
            title:"ciencia ficcion",id:8
        },
        {
            title:"aventura",id:9
        },
        {
            title:"documentales",id:10
        },
        {
            title:"historia",id:11
        },
        {
            title:"familiar",id:12
        }
    ]

   

    const onDrop = React.useCallback((acceptedFiles) =>{
        const file = acceptedFiles[0]
        setFiles(file)
        setUrlVideoForm(URL.createObjectURL(file))

    },[])
    

    const {getRootProps,getInputProps } = useDropzone({
        accept:"image/*",
        maxFiles:3,
        noKeyboard: true,
        onDrop
    })

    const uploadPoster = (filePoster) =>{
        const ref = storage.ref().child(`peliculas/${filePoster}`)
        return ref.put(files)
    }

    React.useEffect(()=>{
        setErrors({title:false})
        db.collection("peliculas").where("title","==",albumName.title.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"")).get().then((response)=>{
            if(response.docs.length>0){
                toast.error("este nombre ya existe")
            }

        })

    },[albumName.title])
  
    const onSubmit= () =>{

        let peliculaOriginal = albumName.urlVideo;
        let trailerOriginal = albumName.urlTrailer;

        let caracterAgregado = "/e";
        let posicion = 21; 
        const peliculaFormateado = peliculaOriginal.substring(0, posicion) + caracterAgregado + peliculaOriginal.substring(posicion);
        const trailerFormateado = trailerOriginal.substring(0, posicion) + caracterAgregado + trailerOriginal.substring(posicion);


        setErrors([])
        
        let error = {}
        let formOK = true

        if(!files&& !albumName?.urlImagePoste){
            toast.error("imagen obligatorio")
            formOK=false
            return
        }else{
            if(!tipoDePelicula){
            toast.error("Tipo de Pelicula obligatorio")
            formOK=false
            return

            }else{
                if(showNotificar){
                    if(!albumName.titleNotificacion && !albumName.messageNotificacion){
                        toast.error("datos obligados para notificar")
                        formOK=false
                        return
                    }
                }

            }

        }
         

        if(formOK)

        if(albumName?.urlImagePoste.length>2){
            setIsloading(true)
            const filePoster = uuidv4()

            db.collection("peliculas").add({
                type: tipoDePelicula ,
                title: albumName.title.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,""),
                titleOriginal:albumName.title.trim(),
                description: albumName?.description,
                video: albumName.urlVideo.trim(),
                trailer: albumName.urlTrailer.trim(),
                createAt:new Date(),
                uuidPoster:filePoster,
                urlPoster:albumName?.urlImagePoste,
                buscar:buscar
                
            }).then(() =>{
                toast.success("Se subio con exito")
                if(showNotificar){

                    const datos = {
                        type: tipoDePelicula ,
                        title: albumName.title.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,""),
                        titleOriginal:albumName.title.trim(),
                        description: albumName.description,
                        video: albumName.urlVideo.trim(),
                        trailer: albumName.urlTrailer.trim(),
                        createAt:new Date(),
                        uuidPoster:filePoster,
                        urlPoster:albumName?.urlImagePoste,
                        titleNotificacion:albumName.titleNotificacion,
                        messageNotificacion:albumName.messageNotificacion,
                        pelicula:true,
                        serie:false,
                        buscar:buscar

                    }

                    db.collection("notificaciones").add(datos).then(()=>{
                        sendNotificationByTopic(albumName?.urlImagePoste,albumName.titleNotificacion,albumName.messageNotificacion,datos)

                    })


                }
            }).finally(() =>{
                setIsloading(false)
                setShowModal(false)
            })


        }else{
            
            setIsloading(true)
            const filePoster = uuidv4()
            uploadPoster(filePoster).on("state_changed",(snapshot) =>{
                const progressPorcentaje = Math.round(
                    (snapshot.bytesTransferred/snapshot.totalBytes)*100
                )
                setPorcentajePoster(progressPorcentaje)
            },
            (err) =>{
            },
            () =>{
    
                storage.ref(`peliculas/${filePoster}`).getDownloadURL().then((url)=>{
    
                    
    
                    db.collection("peliculas").add({
                        type: tipoDePelicula ,
                        title: albumName.title.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,""),
                        titleOriginal:albumName.title.trim(),
                        description: albumName.description,
                        video: albumName.urlVideo.trim(),
                        trailer: albumName.urlTrailer.trim(),
                        createAt:new Date(),
                        uuidPoster:filePoster,
                        urlPoster:url,
                        buscar:buscar
                        
                    }).then(() =>{
                        toast.success("Se subio con exito")
                        if(showNotificar){
    
                            const datos = {
                                type: tipoDePelicula ,
                                title: albumName.title.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,""),
                                titleOriginal:albumName.title.trim(),
                                description: albumName.description,
                                video: albumName.urlVideo.trim(),
                                trailer: albumName.urlTrailer.trim(),
                                createAt:new Date(),
                                uuidPoster:filePoster,
                                urlPoster:url,
                                titleNotificacion:albumName.titleNotificacion,
                                messageNotificacion:albumName.messageNotificacion,
                                pelicula:true,
                                serie:false,
                                buscar:buscar
    
                            }
    
                            db.collection("notificaciones").add(datos).then(()=>{
                                sendNotificationByTopic(url,albumName.titleNotificacion,albumName.messageNotificacion,datos)
    
                            })
    
    
                        }
                    }).finally(() =>{
                        setIsloading(false)
                        setShowModal(false)
                    })
                }).catch((err)=>{
                    toast.error("Error al subir pelicula")
                })
            }
            
            )
        }


        

        

    }

    const sendNotificationByTopic = async (imageUrl,title,message,datos) => {
        const topic = 'peliculas';
        const url = `https://fcm.googleapis.com/fcm/send`;
        const urlImage=imageUrl
      
        const data = {
          to: `/topics/${topic}`,
          priority:"high",
          notification: {
            title: title,
            body: message,
            image:urlImage,
          },
          data:datos
        };
      
        const config = {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer AAAAdK3ICns:APA91bFnjG-bfhcozvxMVbiahuurvuW3diLZgM4n7ou-gF04RQNLnnklfeDWfVc4phcSL0aqZaVe2EwHN6SqBPhoo5pse1ZryyXwDQeHJxWd43vJ74MV2Efq4hSyFCyfka--6qEU1dGR', // Reemplaza [TOKEN_ACCESO] con tu token de acceso
          },
        };
      
        try {
          const response = await axios.post(url, data, config);
        } catch (error) {
        }
      };

      const AgregarBuscar = () =>{

        if(albumName.buscar.length>0){
            buscar.push(albumName.buscar.toLowerCase())
            setReload(!reload)
        }
        
    }

    const deleteButtom = (i)=>{
        const news = buscar.filter((doc)=>doc !==i)
        setBuscar(news)
        setReload(!reload)
    }


      
    return(
        <>

                <Form onSubmit={onSubmit} className="add-banner-form" > 

                
                    <Form.Field className="banner-form-video" >

                        <div 
                            {...getRootProps()}
                            className="banner-video"
                            style={{backgroundImage: `url('${urlVideoForm}')`}}
                        />
                        <input {...getInputProps()} />
                        {!urlVideoForm && <Image src={noImage} />}
                    

                    </Form.Field>
                    <Form.Field>
                        
                        <ListaDeTiposDePeliculas
                            obtenerListaSeleccionada={setTipoDePelicula}
                            arrayLista={lista}
                        />
                        <Input
                            placeholder="Ingrese URL DE IMAGEN"
                            onChange={(e) => setAlbumName({...albumName,urlImagePoste: e.target.value })}
                            
                    />
                    
                    <Input
                            placeholder="Ingrese titulo de la pelicula"
                            onChange={(e) => setAlbumName({...albumName,title: e.target.value })}
                            
                    />
                    <Input
                            placeholder="Ingrese descripcion"
                            onChange={(e) => setAlbumName({...albumName,description: e.target.value })}
                    />
                    <Input
                            placeholder="Ingrese URL TRAILER"
                            onChange={(e) => setAlbumName({...albumName,urlTrailer: e.target.value })}
                    />
                    <Input
                            placeholder="Ingrese URL VIDEO"
                            onChange={(e) => setAlbumName({...albumName,urlVideo: e.target.value })}
                    />
                    {
                        showNotificar && (
                            <>

                                <Input
                                placeholder="Ingrese titulo notificacion"
                                onChange={(e)=>setAlbumName({...albumName,titleNotificacion:e.target.value})}
                                />
                                <Input
                                placeholder="Ingrese Message de notificacion"
                                onChange={(e)=>setAlbumName({...albumName,messageNotificacion:e.target.value})}

                                />
                                
                            </>

                        )
                    }
                    
                    <Button type="submit" loading={iseLoading} >Crear Pelicula</Button>

                    </Form.Field>
                    <Button onClick={()=>setShowNotificar(!showNotificar)}  >Notificar</Button>
                    <Progress percent={porcentajePoster}/>
                    
                </Form>
                <Input
                        placeholder="Buscar"
                        onChange={(e) => setAlbumName({...albumName,buscar: e.target.value })}

                />
                <div className='conatinerButtoms' >
                    {
                        map(buscar,(item,index)=>(
                            <Button
                                key={index}
                                className='buttomAgregados'
                                onClick={()=>deleteButtom(item)}
                                
                            >
                                {item}
                            </Button>
                        ))
                    }
                </div>
                <Button  onClick={()=>AgregarBuscar()}  >agregar</Button>

        </>
    )
}
